<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >添加</el-button
        >
        <!-- <el-button
          size="mini"
          class="filter-item"
          type="danger"
          @click="delRows"
          >删除</el-button
        > -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.Status==2" @click="detailsById(row.DocId)">查看</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="editById(row.DocId)">编辑</el-button>
             <el-button type="text" v-if="row.Status!=2" @click="check(row)">审核</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="delRows(row.DocId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
      <div class="list-head" style="margin-top: 10px;">
      <span>单据信息</span>
    </div>
    <el-table class="tb-c-head" :data="Details" v-loading="isLoading" border  show-summary  :summary-method="getSummaries">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="BarCode" label="条码"   show-overflow-tooltip />
      <el-table-column label="商品名称" prop="GoodsName"/>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="MainUnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量">
        <template slot-scope="{ row }">
          <span>{{row.Quantity}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="Price" label="单价" /> -->
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
          <span >{{row.Price}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" />
      <el-table-column prop="AvailableQuantity" label="可用量" />
      <el-table-column prop="Remark" label="备注" />
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/stock/bismanage/orec/list";
import editDialog from "@/components/stock/bismanage/orec/editDialog";
import detailsDialog from "@/components/stock/bismanage/orec/detailsDialog";

export default {
  name: "bismanage-orec",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog
  },
  data() {
    return {
      api: require("@/api/stock/otherInDoc").default,
      Details: [],
      isLoading: false,
    }
  },
  methods: {
    reload() {
      this.$refs.list.reload();
      this.Details = [];
    },
    onChange(row) {
      this.Details = [];
      this.isLoading = true;
      this.api.info(row.DocId).then((res) => {
        this.isLoading = false;
        if (res.Data) this.Details = res.Data.Goods;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 5 || index === 7) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor( (prev + curr)*100 )/100;
              } else {
                return Math.floor(prev*100)/100;
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    check(row) {
      sessionStorage.setItem('check','1')
      this.$refs.detailsDialog.openEditById(row.DocId);
    },
    detailsById(id){
      this.$refs.detailsDialog.openDetailsById(id);
    },
    delRows(id) {
    this.$confirm("确认删除数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.api.delete(id).then(res => {
          if(res.Code ==0) {
            this.$message.success("删除成功")
            this.$refs.list.reload();
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
      .catch(() => {});
    },
  },
};
</script>